export default __webpack_public_path__ + "static/pt_1-8274d52a5ffb57db7d118b4908f23d13.png";